<template>
  <svg viewBox="-1 -1 2 2">
    <path
      v-for="(slice, index) in slices"
      :key="`d${index}`"
      :d="theD(slice)"
      :style="`fill: ${theStyle(slice)}`"
      :alt="`${slice.label}: ${slice.count}`"
    ></path>
    <circle r="0.7" fill="#ffffff"></circle>
    <text
      style="text-anchor: middle; font-size: 0.03rem; font-weight: bold"
      x="0"
      y="0.1"
    >
      {{ total }}
    </text>
    <text style="text-anchor: middle; font-size: 0.015rem" x="0" y="0.35">
      Teilnahmen
    </text>
  </svg>
</template>

<script>
export default {
  props: {
    results: {
      type: Array,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  computed: {
    slices() {
      let cumulativeRadians = 0

      const results = this.results.map((slice) => {
        const percent = slice.count / this.total
        const startX = Math.cos(cumulativeRadians)
        const startY = Math.sin(cumulativeRadians)
        cumulativeRadians += 2 * Math.PI * percent
        const endX = Math.cos(cumulativeRadians)
        const endY = Math.sin(cumulativeRadians)

        return {
          ...slice,
          percent,
          startX,
          startY,
          endX,
          endY,
          largeArcFlag: percent > 0.5 ? 1 : 0,
        }
      })
      return results
    },
  },
  methods: {
    theD({ startX, startY, largeArcFlag, endX, endY }) {
      return `M ${startX} ${startY} A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY} L 0 0`
    },
    theStyle(slice) {
      return slice.color || ``
    },
  },
}
</script>

<style>
@import '~components/utils/Pie.css';
</style>
